module.exports = __webpack_public_path__ + "img/logo-light.3cbf034d.svg";